/*
 * Copyright (c) 2021. Manchester Economic Forecasting Limited <http://mef-uk.com>
 */

import { createTheme } from '@material-ui/core/styles';
import { red, green } from '@material-ui/core/colors';

// Create a theme instance.
const theme = createTheme({
	palette: {
		primary: {
			main: '#556cd6',
		},
		secondary: {
			main: '#19857b',
		},
		error: {
			main: red.A400,
		},
		background: {
			default: '#fff',
		},
		success: {
			main: green.A400,
		},
	},
});

export default theme;
